import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";

const PayrollsLaborSummary = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="row">
                  <div class="col-md-12">
                    <div className="shadowclass mt-3">
                      <div class="inventory_summary_master">
                        <div class="row-fluid">
                          <div class="col-12">
                            <div class="counts date_new_Cont">
                              <h4 class="event-alert">Select Your Period</h4>

                              <div class="half_new_div d-flex">
                                <a href="#_" class="date_label">
                                  <i class="iconSprites arrow-left"></i>{" "}
                                </a>{" "}
                                <span class="date-text">
                                  May 1, 2022 - May 12, 2022
                                </span>
                                <span class="clander_icon"></span>
                              </div>

                              <div class="half_right_div">
                                <ul class="summary_filter add">
                                  <li class="">
                                    <a href="/finance_summary/general/timeLimit:day">
                                      Day
                                    </a>{" "}
                                  </li>
                                  <li class="">
                                    <a href="/finance_summary/general/timeLimit:week">
                                      Week
                                    </a>{" "}
                                  </li>
                                  <li class="active">
                                    <a href="/finance_summary/general/timeLimit:month">
                                      Month
                                    </a>{" "}
                                  </li>
                                  <li class="">
                                    <a href="/finance_summary/general/timeLimit:quarter">
                                      Quarter
                                    </a>{" "}
                                  </li>
                                  <li class="">
                                    <a href="/finance_summary/general/timeLimit:year">
                                      Year
                                    </a>{" "}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="shadowclass mt-3">
                      <div class="col-12">
                        <div class="select-comparison">
                          <label class="key">Key Statistics Vs.</label>
                          <div class="select-div widthextra">
                            <select
                              name="data[comparison]"
                              class="comparison"
                              id="comparison"
                            >
                              <option value="">Select Comparison</option>
                              <option value="0" selected="selected">
                                Previous Period
                              </option>
                              <option value="1">
                                Same Period Previous Year
                              </option>
                            </select>{" "}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 m-0">
                        <ul class="comparison_listing">
                          <li>
                            <h4>
                              <span class="com-sign">$</span>111{" "}
                            </h4>
                            <p>Avg. Daily Labor Cost</p>
                          </li>
                          <li>
                            <h4>
                              0<span class="com-sign">%</span>
                            </h4>
                            <p>Labor Cost as % of Net Sales</p>
                          </li>
                          <li>
                            <h4>0 </h4>
                            <p> Avg. Staff Dependability Score </p>
                          </li>
                          <li>
                            <h4>
                              0<span class="com-sign">%</span>
                            </h4>
                            <p>Overtime as % of Labor Cost</p>
                          </li>
                          <li>
                            <h4>
                              0<span class="com-sign">%</span>
                            </h4>
                            <p>Actual vs. Scheduled Hours Var.</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default PayrollsLaborSummary;
